import React, { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import {
  WidgetPrintHeader,
  Container,
  BodyPrint,
} from '@mummssoftware/common-ui';
import { PNCounterContext } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_PATIENT_CARE_PLAN_FREQUENCY } from '@mummssoftware/global-context/PNCounter/constants';
import { showPrintNotes } from '@mummssoftware/utils/utils';
import { PrintNotes } from './PrintNotes';
import CarePlanFrequencyTable from '../../components/sections/CarePlanFrequencyTable';
import { CarePlanFrequencyContext } from '../../context';
import defaults from '../../translations/en.json';

const PrintTable = styled.div`
  width: fit-content;
  margin: auto;
`;
// way to get next page break with global printing
const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

const texts: NonNullable<mumms.JSONObject> = defaults;

type CarePlanFrequencyViewPrintProps = {
  onWidgetReady?: (arg: mumms.ComponentName) => void;
  rgHash: mumms.HashedRoleGroup;
  viewModePrint: boolean;
};

const CarePlanFrequencyViewPrint = ({
  onWidgetReady,
  rgHash,
  viewModePrint,
}: CarePlanFrequencyViewPrintProps) => {
  const { printConfig, observation, patient, agency, idgData } = useContext(
    CarePlanFrequencyContext,
  );
  const { countValues } = useContext(PNCounterContext);
  const pcpfNotes =
    countValues &&
    patient &&
    countValues[patient.patientNumber][ENTITY_PATIENT_CARE_PLAN_FREQUENCY];
  const [cppNotes, setCPPnotes] = useState<any>(null);
  const showNotes = showPrintNotes(printConfig);

  useEffect(() => {
    // make API calls when needed
    // => only when printing
    // => only if pcpf Notes
    // => only when idg data is not provided
    if (!idgData && showNotes && pcpfNotes && pcpfNotes.length) {
      getNotes();
    }
  }, [JSON.stringify(pcpfNotes)]);
  const roleGroups = Object.values(rgHash);
  const newPlans = roleGroups.map((roleGroup: mumms.RoleGroup) =>
    Object.values(roleGroup.frequencies).filter((plan: any) => plan.id),
  );
  const flatPlans = newPlans.flat();
  // in case a row is being edited when user goes to ribbon print
  flatPlans.forEach((plan) => {
    plan.editing = false;
  });

  const getNotes = async () => {
    const pnNotes =
      observation &&
      (await observation.getWidgetPnNotes(
        patient?.patientNumber as string,
        agency as string,
        ENTITY_PATIENT_CARE_PLAN_FREQUENCY,
      ));
    setCPPnotes(pnNotes);

    // @note save in global context but refactor on PN Context coming
  };

  // on component did mount
  useEffect(() => {
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('CarePlanFrequency' as mumms.ComponentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container>
      <BodyPrint>
        <WidgetPrintHeader title={texts.printTitle as string} />
        <PrintTable>
          <CarePlanFrequencyTable
            smallWidget={false}
            viewModePrint={viewModePrint}
            rgHash={rgHash}
          />
          <PrintNotes
            cppNotes={idgData?.notes || cppNotes}
            plans={(idgData?.frequencies as any) || flatPlans}
          />
        </PrintTable>
      </BodyPrint>
      <PageBreak />
    </Container>
  );
};

export default CarePlanFrequencyViewPrint;
